import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateCategory = async (payload) => {
  try {
    const response = await APIs.post('/create_categroy', payload);

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllCategory = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_category/${payload.page}/${payload.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllMajorCategory = async () => {
  try {
    const response = await APIs.get(`/get_all_major_category`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadCategoryImage = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadCategoryIcon = async (payload) => {
  try {
    const response = await APIs.post(`/upload_through_cloudinary`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully uploaded');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteCategory = async (payload) => {
  try {
    const response = await APIs.post(`/delete_category`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully deleted');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleCategoryDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_category/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditCategory = async (payload) => {
  try {
    const response = await APIs.patch(
      `/edit_category/${payload?._id}`,
      payload
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForCategoryByName = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_category_by_name/${payload?.name}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const CategoryServices = {
  CreateCategory,
  getAllCategory,
  uploadCategoryImage,
  uploadCategoryIcon,
  DeleteCategory,
  getSingleCategoryDetails,
  EditCategory,
  getAllMajorCategory,
  SearchForCategoryByName,
};

export default CategoryServices;
